import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import googleIcon from "assets/svg/google.svg";
import logoSgbWhite from "assets/svg/logo-sgb-white.svg";
import logoP3m from "assets/svg/logo-title.svg";
import logoP3mWhite from "assets/svg/logo-title-white.svg";
import * as Styled from "./styles";
import { FaUser } from "react-icons/fa";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { CustomTooltip } from "components/Tooltip";
import { clearStoredPreferences, useAuth } from "contexts/AuthContext";
import { Environment } from "shared/environments";

function loginUrl(provider: 'google' | 'govbr') {
  return `${Environment.API_URL_BASE.replace(/\/$/, '')}/auth/${provider}/login/`;
}

export default function Login() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const error = new URLSearchParams(location.search).get('error');

  useEffect(() => {
    if (!user) {
      clearStoredPreferences();
      window.dispatchEvent(new CustomEvent('p3m:clearMapDisplay'));
    }
  }, [user]);

  const handlePublicAccess = () => {
    clearStoredPreferences();
    window.dispatchEvent(new CustomEvent('p3m:clearMapDisplay'));
    sessionStorage.setItem('p3m_anonymous_session', 'active');
    navigate('/map');
  };

  if (user) return <Navigate to="/" replace />;

  return (
    <>
      <Styled.Wrapper>
        <Styled.Header>
          <img src={logoP3mWhite} className="logo-p3m" style={{ width: "420px" }} />
          <img src={logoSgbWhite} />
        </Styled.Header>

        <Styled.Card>
          <img src={logoP3m} className="logo-p3m" />
          <Styled.Buttons>
            {error && <Styled.Error role="alert">{error}</Styled.Error>}
            <div>
              <Styled.LoginButton type="button" onClick={handlePublicAccess}>
                <FaUser />
                Acesso público
                <CustomTooltip
                  title="Camadas ativas, filtros e outras alterações da navegação não serão salvas neste acesso."
                  placement="top"
                  disableInteractive
                >
                  <span className="public-access-info" aria-label="Aviso sobre acesso público">
                    <InfoOutlinedIcon />
                  </span>
                </CustomTooltip>
              </Styled.LoginButton>
            </div>
            <div>
              <Styled.LoginButton type="button" onClick={() => window.location.assign(loginUrl('google'))}>
                <img src={googleIcon} alt={"google"} />
                Entrar com Google
              </Styled.LoginButton>
            </div>
            <div>
              <Styled.GovLoginButton onClick={() => window.location.assign(loginUrl('govbr'))}>
                Entrar com&nbsp;<img src="https://www.gov.br/++theme++padrao_govbr/img/govbr-colorido-b.png" alt="gov.br"/>
              </Styled.GovLoginButton>
            </div>
          </Styled.Buttons>

        </Styled.Card>

        <Styled.Footer />
      </Styled.Wrapper>
    </>
  );
}
